import "./gallery-style.css";
import {GalleryProps} from "./GalleryProps";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import {GallerySliderConfig} from "./GallerySliderConfig";

export const Gallery = (gallery: GalleryProps) => {
    return (
        <section className={'Gallery'} id={'gallery'}>
            <div className={'container'}>
                <h1 className={"section__title"}>Как проходят наши вечеринки</h1>
                <Swiper {...GallerySliderConfig} className={'swiper'}>
                    {gallery.gallery.map((slide, index) => (
                        <SwiperSlide key={index} className={'swiper gallery-slide'}>
                            <img src={slide.img} alt={slide.alt} loading={"lazy"}/>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
            </div>
        </section>
    );
}